export default __webpack_public_path__ + "media/music/2c28b1d78084c5a0842d12c322fbb717.mp3";